import React from 'react';
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import Datepicker from "components/DatePicker/DatePicker";

interface DateTimeSettingsProps {
    object: any;
    datePickerState: "withTime" | "normal";
    setDatePickerState: (state: "withTime" | "normal") => void;
    defaultValueDateTimeNow: boolean;
    setDefaultValueDateTimeNow: (value: boolean) => void;
    setDateDefaultValue: (value: string | null) => void;
    resetForm: boolean;
}

export const DateTimeSettings: React.FC<DateTimeSettingsProps> = ({
    object,
    datePickerState,
    setDatePickerState,
    defaultValueDateTimeNow,
    setDefaultValueDateTimeNow,
    setDateDefaultValue,
    resetForm
}) => {
    return (
        <>
            {object?.typeName === 'date' && (
                <>
                    <div className="col-6">
                        <div className="d-flex align-items-center w-100 h-100">
                            <CheckableButton
                                type="radio"
                                labelText="withTime"
                                inputName="DatePickerState"
                                onchange={() => setDatePickerState("withTime")}
                                defaultChecked={datePickerState === "withTime"}
                            />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="d-flex align-items-center w-100 h-100">
                            <CheckableButton
                                type="radio"
                                labelText="normal"
                                inputName="DatePickerState"
                                onchange={() => setDatePickerState("normal")}
                                defaultChecked={datePickerState === "normal"}
                            />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="d-flex align-items-center w-100 h-100">
                            <CheckableButton
                                type="checkbox"
                                labelText="DefaultValue_DateTimeNow"
                                inputName="defaultValueDateTimeNow"
                                onchange={(e) => setDefaultValueDateTimeNow(e)}
                                defaultChecked={defaultValueDateTimeNow}
                            />
                        </div>
                    </div>
                </>
            )}
            <div className="col-12">
                <div>
                    <Datepicker
                        mode={!defaultValueDateTimeNow ? "edit" : "view"}
                        resetForm={resetForm}
                        lable="defaultValue"
                        setIsoTime={(isoTime: string) => { setDateDefaultValue(isoTime) }}
                        val={object?.dateDefaultValue || null}
                        withTime={object?.typeName === "time" ? true : datePickerState === "withTime"}
                        disableDayPicker={object?.typeName === "time"}
                        required={false}
                        calendarPosition="right"
                        format={object?.typeName === "time" ? "۱۳:۲۶" : datePickerState === "withTime" ? "۱۴۰۳/۰۴/۰۴ ۱۳:۲۶" : "۱۴۰۳/۰۴/۰۴"}
                        onOpenPickNewDate={true}
                    />
                </div>
            </div>
        </>
    );
}; 